export const theme = {
  box: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',

    border: '1px solid #dee2e6',
    borderRadius: '5px',
    padding: '10px 5px',
    marginBottom: '5px',

    cursor: 'pointer',
  },
  icon: { marginRight: '7px' },
  boxText: {
    textAlign: 'center',
    wordBreak: 'break-word',
  },
  list: {
    listStyle: 'none',
  },
  text: {
    fontSize: '0.8rem',
    marginBottom: '2px',
  },
};
